import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from '../../hooks/useNavigate';
import { send } from 'loot-core/platform/client/fetch';
import { closeModal, setAppState } from 'loot-core/client/actions';
import { useDispatch } from 'react-redux';
import { useSessionFlag } from '../../hooks/useSessionFlag';

export function AuthCallbackGoogle() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { refreshAuthState } = useAuth();
  const [postAuth] = useSessionFlag('postAuth');
  const code = searchParams.get('code');

  useEffect(() => {
    async function run() {
      dispatch(
        setAppState({
          loadingText: 'Logging in...',
        }),
      );

      if (isAuthenticated || !code) {
        navigate('/');
      } else {
        const { isSignup } = await send('subscribe-oauth-exchange-code', {
          code,
        });

        await refreshAuthState();
        dispatch(closeModal());

        if (isSignup) {
          navigate('/entry-mode');
        } else {
          if (postAuth === 'ynab') {
            navigate('/onboarding');
          } else {
            navigate('/');
          }
        }

        dispatch(
          setAppState({
            loadingText: null,
          }),
        );
      }
    }

    run();
  }, []);

  return <></>;
}
